import React, {useEffect, useState} from "react";
import "./ProductResponsive.scss";
import {useHistory, useParams} from "react-router";
import {useDispatchBasket,useBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import {clothing_product} from "../Clothing/Services_Clothing";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import {ArrowLeftOutlined,PlusCircleOutlined,MinusCircleOutlined} from '@ant-design/icons';
import {openNotificationWithIcon, Setup} from "../../Services";



function AttrSec({sec}){
    return(
        <div className="description-section-item">
            {sec.map(m=>{
                switch(m.type){
                    case 'h2':
                        return(
                            <div className="description-section-item-title">
                                <span>{m.text}</span>
                            </div>
                        )
                        break;
                    case 'p':
                        return(
                            <div className="description-section-item-desc">
                                <p>{m.text}</p>
                            </div>
                        )
                        break;
                    case 'li':
                        return(
                            <div className="description-section-item-li">
                                <li>{m.text}</li>
                            </div>
                        )
                        break;
                }
            })}
        </div>
    )
}


function AddToBasket({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const {merchantId,productId} = useParams()
    const history = useHistory()

    //states
    const [loading,set_loading] = useState(false)



    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            openNotificationWithIcon('success',item,history,merchantId)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
        }else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
        }

    }

    const dec = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
            }
        }
    }

    const remove = () =>{
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product=>product?.product?.uid!==item?.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(()=>{
            localStorage.setItem("basket",JSON.stringify(basket));
        },500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product=>product?.product?.uid===item?.uid);
        if(basket_count){
            return basket_count.count;
        }
        return 0;
    }


    return(
        <div className="add-remove-section-footer" style={{
            backgroundColor: '#05E5AF',
            margin: '20px 24px',
            borderRadius: 5,
            padding: '10px 13px',
            fontFamily:'YekanRegular'
        }}>
            {checkCount()<1?<span className="add-btn-text" style={{width:'100%'}}  onClick={inc}>

                <div className="buy-btn" style={{margin:0}}>
                {/*<div className="price">*/}
                {/*    <span> { numberWithCommas(item.price)} ریال </span>*/}
                {/*</div>*/}
                <div className="title" style={{fontFamily:'YekanBold'}}>
                    <span>افزودن به سبد خرید</span>
                </div>
            </div>
                </span>:
                <div className="active-footer-sec">
                    <div className="price-footer-sec">
                        <div className="percent-off-footer-cont">
                            {item && item.discount_percentage!==0?
                                <span className="percent-off-footer"
                                      style={{width:25,height:25,fontSize:12}}
                                >%{item.discount_percentage}</span>:
                                null
                            }

                            {/*<span style={{textDecoration:"line-through",fontSize:14}}>{numberWithCommas(checkCount()*item.price_original)}</span>*/}
                        </div>
                        <div style={{direction:"rtl"}}><span>{numberWithCommas(checkCount()*item.price)} ریال </span></div>
                    </div>
                    <div className="calc">
                        {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:null}*/}
                        {checkCount()>0?<>
                            <i className="fa fa-minus" onClick={dec}></i>
                            <span style={{direction:"rtl",padding:"0 16px",
                                color: 'black',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }} className="product-count-number">
                            {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                        </span>
                        </>:null}
                        <i className="fa fa-plus" onClick={inc}></i>
                    </div>
                </div>
            }
        </div>
    )
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function ProductResponsive() {

    //hooks
    const {merchantId,productId} = useParams()
    const history = useHistory()

    const [images,set_images] = useState([])
    const [mainImage,set_mainImage] = useState("")


    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        getProduct()
        getToken()
    },[])

    const [token,set_token] = useState(null)
    const getToken = ()=>{
        set_token(localStorage.getItem('token'))
    }


    const [product,set_product] = useState({})


    const [color,set_color] = useState('#DE7B50')
    const [size,set_size] = useState('S')


    const getProduct = async () =>{
        const response = await clothing_product(merchantId,productId);
        console.log(response.data)
        response.data['sizes'] =['S','L','XL'];
        response.data['colors'] =['#C4C4C4','#B88942','#DE7B50','#E06B6B'];
        response.data['desc'] ="دم رازاب هب یراج لاس رد هک نوتیو ییول هزییاپ لدم نیزت هزات\n" +
            "یلصا گنر رهچ رد هدش وربور یدایز لابقتسا اب و هدش هضرع";


        set_product(response.data)
        let imagesArr = []
        if(response.data.extra_images && response.data.extra_images.addresses.length>0 ){
          imagesArr = response.data.extra_images.addresses.map(i=> (Setup.file_endpoint+"/"+i).replace("#", "%23"))
        }

        if(response.data.image)
            imagesArr.push(response.data.image);

        set_mainImage(response.data.image)
        set_images(imagesArr)

    }


    const changeImage = (i)=>{
        set_mainImage(i)
    }

    return(
        <>
            <HeaderDesktop mId={merchantId} active="shop"/>
        {/*<div className="product-desktop-container">*/}
        {/*    <div className="bread-sec" onClick={e=>{*/}
        {/*        history.goBack();*/}
        {/*    }}>*/}
        {/*        <ArrowLeftOutlined />*/}
        {/*        <span>بازگشت به صفحه جستجو</span>*/}
        {/*    </div>*/}
        {/*   <div className="product-desktop-wr">*/}
        {/*       <div className="product-desktop-info">*/}
        {/*           <div className="product-desktop-info-title">*/}
        {/*               <span>{product.name}</span>*/}
        {/*           </div>*/}
        {/*           <div className="product-desktop-info-price">*/}
        {/*               <span>{product.price} ریال</span>*/}
        {/*           </div>*/}
        {/*           <div className="product-desktop-info-desc">*/}
        {/*               <p>{product.des}</p>*/}
        {/*               /!*<p>توضیحات مورد نظر شما درباره هر محصول در این جا قرار خواهد گرفت. این متن را از صفحه مدیریت سایت، مدیریت فروشگاه، محصولات می‌توانید حذف کنید یا تغییر دهید.*!/*/}

        {/*               /!*    توضیحات محصول می‌تواند بصورت بولد باشد یا آن را به صورت ایتالیک در آورید یا تغییرات لازم را روی آن اعمال کنید</p>*!/*/}
        {/*           </div>*/}

        {/*           {token?<div className="product-desktop-add">*/}
        {/*               <AddToBasket item={product}/>*/}
        {/*           </div>:null}*/}
        {/*       </div>*/}

        {/*       <div className="product-desktop-image">*/}
        {/*           <img src={product.image} alt=""/>*/}
        {/*       </div>*/}
        {/*   </div>*/}


        {/*</div>*/}

        <div className="product-detail-container">
            {/*top section*/}
            <div className="top-section">
                <div className="top-row">




                    {/*product info section*/}
                    <div className="product-detail-info">

                        <div className="product-detail-info-basic">
                            <div className="product-detail-info-basic-item bold-item">
                                <span className="label">{product.name}</span>
                            </div>

                            <div className="product-detail-info-basic-item">
                                <span className="label">{product.enName}</span>
                            </div>

                            <div className="product-detail-info-basic-item">
                                <span className="label">{product?.brand?.name}</span>
                            </div>

                            <div className="product-detail-info-basic-item">
                                <span className="label">{product?.des}</span>
                            </div>
                        </div>

                        <div className="product-detail-info-price">


                            <div className="product-detail-info-price-input">
                                <span>ریال</span>
                                <span className="product-detail-info-price-input-value">{numberWithCommas(product?.price)}</span>
                            </div>

                            {product?.price!==product?.price_original?<div className="product-detail-info-price-input">
                                <span>ریال</span>
                                <span className="product-detail-info-price-input-off-value">{numberWithCommas(product?.price_original)}</span>
                            </div>:null}



                            <div className="product-detail-info-price-label">
                                <span>قیمت</span>
                            </div>
                        </div>



                        {/*<div className="product-detail-info-price">*/}

                        {/*    <div className="product-detail-info-pallet"></div>*/}
                        {/*    <div className="product-detail-info-pallet"></div>*/}
                        {/*    <div className="product-detail-info-pallet"></div>*/}
                        {/*    <div className="product-detail-info-pallet"></div>*/}

                        {/*    <div className="product-detail-info-price-label">*/}
                        {/*        <span>طعم , سایز , وزن ...</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}


                        {/*<div className="product-detail-info-price">*/}

                        {/*    <div className="product-detail-info-count" style={{width:300}}>*/}
                        {/*        /!*<MinusCircleOutlined style={{fontSize:20}} />*!/*/}
                        {/*        /!*<span className="product-detail-info-count-val">4</span>*!/*/}
                        {/*        /!*<PlusCircleOutlined style={{fontSize:20}} />*!/*/}

                        {/*                   /!*{token?<div className="product-desktop-add">*!/*/}
                        {/*                   /!*    <AddToBasket item={product}/>*!/*/}
                        {/*                   /!*</div>:null}*!/*/}
                        {/*    </div>*/}

                        {/*    <div className="product-detail-info-price-label">*/}
                        {/*        <span>تعداد</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="add-to-basket">
                                <div className="product-desktop-add" style={{width:300}}>
                                <AddToBasket item={product}/>
                            </div>
                        </div>

                        {/*<div className="product-detail-info-add-btn">*/}
                        {/*    <span>افزودن به سبد خرید</span>*/}
                        {/*</div>*/}

                        <div className="product-detail-divider">

                        </div>


                        <div className="product-detail-extra-data">

                            <div className="product-detail-extra-data-row">
                                <div className="product-detail-extra-data-item">
                                    <span className="value-bordered">{product.uid}</span>
                                    <span className="value">شناسه محصول</span>
                                </div>
                                <div className="product-detail-extra-data-item">
                                    <span className="value-bordered">{product.barcode}</span>
                                    <span className="value">بارکد وارداتی</span>
                                </div>
                            </div>

                            <div className="product-detail-extra-data-row">
                                <div className="product-detail-extra-data-item">
                                    <span className="value">-----------</span>
                                    <span className="value">کشور سازنده</span>
                                </div>
                                <div className="product-detail-extra-data-item">
                                    <span className="value">-----------</span>
                                    <span className="value">تحت لایسنس</span>
                                </div>
                            </div>

                        </div>


                    </div>


                    {/*images section*/}

                    <div className="product-detail-images">
                        <div className="product-detail-images-main">
                            <Zoom>
                                <img src={mainImage} alt=""/>
                            </Zoom>

                        </div>
                        <div className="product-detail-images-list">
                            {images.map(i=>{
                                return(
                                    <div className="product-detail-images-item" onClick={e=>changeImage(i)}>
                                        <img src={i} alt=""/>
                                    </div>
                                )
                            })}

                        </div>
                    </div>


                </div>

            </div>


            <div className="description-section">

                <div className="description-section-header">
                    <span>اطلاعات محصول</span>
                </div>

                <div className="description-section-body">

                    {product?.extra_info?.texts?.map(t=>{
                        return(
                            <AttrSec sec={t}/>
                        )
                    })}

                </div>

            </div>

        </div>


            <br/><br/>
            <FooterDesktop/>
            </>
    )

}
export default ProductResponsive
